import axios from 'axios';
import router from '../router/index'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 12000
});
// 请求拦截
service.interceptors.request.use(
    config => {
        var token = localStorage.getItem("token")
        if (token) {
            config.headers['X-Access-Token'] = token
        }
        return config;
    },
    error => {
        return Promise.reject();
    }
);
// 响应拦截
service.interceptors.response.use(response => {
        if (response.status === 200) {
                return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        return Promise.reject();
    }
);

export default service;
